"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledIconContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _Icon = require("./Icon.constants");

var _templateObject;

var _default = {};
exports["default"] = _default;

var StyledIconContainer = _styledComponents["default"].div.withConfig({
  displayName: "Iconstyles__StyledIconContainer",
  componentId: "sc-1fg9hhw-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    w-100\n    ", "\n  "])), function (_ref) {
  var size = _ref.size;
  return "mw".concat(_Icon.sizes[size]);
}));

exports.StyledIconContainer = StyledIconContainer;